"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _companyappApi = require("@/api/companyappApi");
var _utils = require("@/utils");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var AUDIT_STATUS = {
  CREATED: '已创建',
  WAITING_API: '等待微信接口',
  SUBMITTING: '提交中',
  PENDING: '审核中',
  DELAYED: '审核延后',
  PASSED: '审核通过',
  REJECTED: '审核驳回',
  WITHDRAWN: '已撤回',
  FAILED: '提交失败'
};
var _default = exports.default = {
  name: 'AuditDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      auditId: null,
      record: null,
      wechatResult: null,
      wechatAuditStatus: null,
      queryError: '',
      queryTime: null,
      requestSeq: 0
    };
  },
  computed: {
    statusMismatch: function statusMismatch() {
      return !!(this.record && this.wechatAuditStatus && this.wechatAuditStatus !== this.record.auditStatus);
    },
    localFields: function localFields() {
      var row = this.record || {};
      return [{
        label: '审核记录 ID',
        value: row.id
      }, {
        label: '微信审核单',
        value: row.wechatAuditId
      }, {
        label: 'AppID',
        value: row.appId
      }, {
        label: '上传版本记录 ID',
        value: row.versionId
      }, {
        label: '版本号',
        value: row.versionNo
      }, {
        label: '本地审核状态',
        value: this.statusLabel(row.auditStatus)
      }, {
        label: '接口环境',
        value: row.environmentCode
      }, {
        label: '提交人',
        value: row.operatorName
      }, {
        label: '分支',
        value: row.branchName,
        full: true
      }, {
        label: 'Commit SHA',
        value: row.commitSha,
        full: true
      }, {
        label: '提审版本描述',
        value: row.versionDesc,
        full: true
      }, {
        label: '本地提审时间',
        value: this.formatTime(row.submitTime)
      }, {
        label: '本地完成时间',
        value: this.formatTime(row.finishTime)
      }, {
        label: '记录创建时间',
        value: this.formatTime(row.createTime)
      }, {
        label: '记录更新时间',
        value: this.formatTime(row.updateTime)
      }, {
        label: '已保存驳回原因',
        value: row.rejectReason,
        full: true
      }, {
        label: '已保存接口错误',
        value: row.errorMessage,
        full: true
      }];
    },
    wechatFields: function wechatFields() {
      var wx = this.wechatResult || {};
      return [{
        label: '微信返回审核单',
        value: wx.auditId
      }, {
        label: '微信实时状态',
        value: wx.status == null ? '-' : "".concat(this.statusLabel(this.wechatAuditStatus), "\uFF08").concat(wx.status, "\uFF09")
      }, {
        label: '微信版本号',
        value: wx.userVersion
      }, {
        label: '本次查询时间',
        value: this.formatTime(this.queryTime)
      }, {
        label: '微信提审时间',
        value: this.formatTime(wx.submitAuditTime, true),
        full: true
      }, {
        label: '微信版本描述',
        value: wx.userDesc,
        full: true
      }, {
        label: '微信驳回原因',
        value: wx.reason,
        full: true
      }, {
        label: '审核截图 ID / URL',
        value: wx.screenShot,
        full: true
      }];
    },
    screenshotUrls: function screenshotUrls() {
      var value = this.wechatResult && this.wechatResult.screenShot;
      if (!value) return [];
      var urls = String(value).match(/https?:\/\/[^\s"'<>|丨，]+/g) || [];
      return _toConsumableArray(new Set(urls.map(function (url) {
        return url.replace(/[\],;；}]+$/, '');
      })));
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.requestSeq += 1;
  },
  methods: {
    open: function open(row) {
      this.visible = true;
      this.auditId = row.id;
      this.record = _objectSpread({}, row);
      this.loadDetail();
    },
    loadDetail: function () {
      var _loadDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var seq, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(!this.visible || !this.auditId)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              seq = ++this.requestSeq;
              this.loading = true;
              this.wechatResult = null;
              this.wechatAuditStatus = null;
              this.queryError = '';
              this.queryTime = null;
              _context.p = 2;
              _context.n = 3;
              return (0, _companyappApi.getMiniProgramAuditDetailApi)(this.auditId);
            case 3:
              data = _context.v;
              if (!(seq !== this.requestSeq || !this.visible)) {
                _context.n = 4;
                break;
              }
              return _context.a(2);
            case 4:
              this.record = data.record;
              this.wechatResult = data.wechatResult || null;
              this.wechatAuditStatus = data.wechatAuditStatus;
              this.queryError = data.wechatQueryError || '';
              this.queryTime = data.queryTime;
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              if (seq === this.requestSeq && this.visible) {
                this.queryError = '详情请求失败，当前仅展示已加载的本地记录，请稍后重试。';
              }
            case 6:
              _context.p = 6;
              if (seq === this.requestSeq) this.loading = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 5, 6, 7]]);
      }));
      function loadDetail() {
        return _loadDetail.apply(this, arguments);
      }
      return loadDetail;
    }(),
    close: function close() {
      this.visible = false;
      this.handleClose();
    },
    handleClose: function handleClose() {
      this.requestSeq += 1;
      this.loading = false;
    },
    statusLabel: function statusLabel(status) {
      return AUDIT_STATUS[status] || (status === 'UNKNOWN' ? '未知状态' : status || '-');
    },
    displayText: function displayText(value) {
      if (value == null || value === '') return '-';
      return String(value).replace(/<br\s*\/?\s*>/gi, '\n').replace(/<[^>]+>/g, '');
    },
    formatTime: function formatTime(value) {
      var seconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return value ? (0, _utils.parseTime)(seconds ? Number(value) * 1000 : value, '{y}-{m}-{d} {h}:{i}:{s}') : '-';
    },
    formatJson: function formatJson(value) {
      if (!value) return '暂无数据';
      try {
        return JSON.stringify(typeof value === 'string' ? JSON.parse(value) : value, null, 2);
      } catch (_unused2) {
        return String(value);
      }
    }
  }
};